import Cookies from 'js-cookie'
import { getUserInfo, getUA } from '@penguin/utils'
import queryString from 'query-string'

/**
 *
 * @returns 从本地或者app获取token
 */
export const getToken = (): string => {
  const parsed: any = queryString.parse(window.location.search)
  if (parsed?.token) {
    localStorage.setItem('token', parsed.token)
  }
  const userInfo = getUA() === 'app' || getUA() === 'merchantApp' ? (getUserInfo() as UserInfo) : {}
  return (
    parsed?.token ||
    localStorage.getItem('token') ||
    Cookies.get('AppToken') ||
    userInfo?.token ||
    ''
  )
}
